import { Injectable } from '@angular/core';

/**
 * Firebase Cloud Messaging device token provider.
 *
 * TODO: wire up the real Firebase SDK (firebase/messaging) here, request
 * notification permission, and return `getToken(messaging, { vapidKey })`.
 * Until Firebase config is provided, this returns an empty string so the
 * login payload stays valid (`fcmToken: ''`) without breaking the request.
 */
@Injectable({ providedIn: 'root' })
export class FcmService {
  async getDeviceToken(): Promise<string> {
    try {
      const cached = localStorage.getItem('mcp_fcm_token');
      if (cached) return cached;
      return '';
    } catch {
      return '';
    }
  }
}
